import { reducerWrapper } from '../support/utils';
import { ALERT_NOTIFICATION_GET_ALERTS } from '../actions/AlertNotificationsActions';
import type { Alert } from '../../../../shared/types/alertNotifications.types';

export type AlertNotificationsReducer = {
  alerts: Alert[];
};

export const INIT_STATE: AlertNotificationsReducer = {
  alerts: [],
};

function Handler(state, action) {
  switch (action.type) {
    case ALERT_NOTIFICATION_GET_ALERTS.response:
      return {
        ...state,
        alerts: action.data.data,
      };
    default:
      return state;
  }
}

const AlertNotifications = reducerWrapper(INIT_STATE, Handler, {
  request: [ALERT_NOTIFICATION_GET_ALERTS],
  error: [ALERT_NOTIFICATION_GET_ALERTS],
  resetOn: ['APP_CHANGE'],
});

export default AlertNotifications;
